import React from "react";
import {useStyles} from "./styles/ComponentsStyle";
import {useHistory} from "react-router-dom";
import {
    Box,
    Button,
    Typography,
} from "@material-ui/core";
import clsx from "clsx";
import { ReactComponent as ArrowLeftIcon } from '../../../common/images/ArrowLeftIcon.svg';
import {inject, observer} from "mobx-react";
import {URL_TYPE} from "../../../routes/Routes";

 function EduContentsButtonGroup(props) {
    const classes = useStyles();
    const history = useHistory();
    const goBackToList = () => {
        history.push(URL_TYPE.ContentList);
    }

    const saveContent  = () => {
        if  (props.contentStore.onSave !== null) {
            props.contentStore.onSave();
        }
    }

    return (
        <div className={classes.root}>
            <Box display={"flex"} justifyContent={"space-between"} alignItems={"center"} className={classes.buttonGroup}>
                <Box className={classes.listButtonStyle}>
                    <Button disableRipple onClick={goBackToList}>
                        <ArrowLeftIcon />
                        <Typography>목록</Typography>
                    </Button>
                </Box>
                <Box display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
                    <Box className={props.currentStep === 0 ? clsx(classes.buttonStyle2Active, classes.buttonStyle2) : clsx(classes.buttonStyle2Active)} style={{marginRight: 16}}>
                        <Button disableRipple onClick={props.handleBack} disabled={props.currentStep === 0}>
                            <Typography>이전</Typography>
                        </Button>
                    </Box>
                    <Box className={
                        props.contentStore.isReadyToSaveContent ?
                            clsx(classes.buttonStyle2Active)
                            : clsx(classes.buttonStyle2Active, classes.buttonStyle2)
                    }>
                        <Button disableRipple onClick={saveContent} disabled={!props.contentStore.isReadyToSaveContent}>
                            <Typography>저장</Typography>
                        </Button>
                    </Box>
                    <Box className={props.contentStore.isReadyToMoveExit ? clsx(classes.buttonStyle3, classes.buttonStyle3Active) : clsx(classes.buttonStyle3) }>
                        {props.currentStep === 6 ?
                            <Button disableRipple onClick={goBackToList} disabled={!props.contentStore.isReadyToMoveExit}>
                                <Typography>완료</Typography>
                            </Button>
                            :
                            <Button disableRipple onClick={props.handleNext} disabled={!props.contentStore.isReadyToMoveExit}>
                                <Typography>다음</Typography>
                            </Button>
                        }
                    </Box>
                </Box>
            </Box>
        </div>
    );
}
export default inject('contentStore')(observer(EduContentsButtonGroup))
